angular.module('impactx.cscontract').controller('CSCToleranceDialogCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'TranslationService',
    'ToolbarService',
    'PartialDialogsService',
    CSCToleranceDialogCtrl
]);

function CSCToleranceDialogCtrl($scope, dataGen, $routeParams, ToastService, BackService, TranslationService, ToolbarService, PartialDialogsService) {
    var self = this;
    self.save = function($event) {
        return dataGen.postAsForm($scope, {toleranceData: $scope.data}, "/cscontract/tolerance/save").then(function(){
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.cscId, 'csctolerance', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };
    
    $scope.showTotal = impactX.isDefined($scope, "data.totalPrice.relative.use.value") || impactX.isDefined($scope, "data.totalPrice.absolute.use.value");
    $scope.showSingle = impactX.isDefined($scope, "data.singlePrice.relative.use.value") || impactX.isDefined($scope, "data.singlePrice.absolute.use.value");
    $scope.showAmount = impactX.isDefined($scope, "data.amounts.relative.use.value") || impactX.isDefined($scope, "data.totalPrice.amounts.use.value");

    $scope.toggleTotal = function(){
        $scope.showTotal = !$scope.showTotal;
    };

    $scope.toggleSingle = function(){
        $scope.showSingle = !$scope.showSingle;
    };

    $scope.toggleAmount = function(){
        $scope.showAmount = !$scope.showAmount;
    };

    $scope.testMin=0;
    $scope.testMax=0;

    dataGen.getData($scope, {cscId: $routeParams.cscId}, "/cscontract/tolerance/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}